



























































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import VarietySearch from '@/app/components/Variety/VarietySearch.vue'
import VarietyListHeader from '@/app/components/Variety/VarietyListHeader.vue'
import VarietyList from '@/app/components/Variety/VarietyList.vue'
/* api */
import VarietyListApi from '@/app/model/api/varietyListApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    VarietySearch,
    VarietyListHeader,
    VarietyList
  }
})
export default class variety extends Vue {
  private varietyData: any = {}
  private count: number = 0
  private notDataMessage: boolean = false
  private showList: boolean = false
  private showLoading: boolean = true
  private complateMessage: string = this.$store.state.alertState.message

  created () {
    this.getVarietyList()
  }

  private getVarietyList () {
    (async () => {
      const data = {
        word: this.$store.state.varietyState.searchText,
        order_name: this.$store.state.varietyState.orderName,
        sort: this.$store.state.varietyState.sortAsc
      }

      const result = await VarietyListApi.getVarietyList(data)

      if (result.isOk()) {
        this.varietyData = result.getPayload()
        this.count = result.getPayload().result_count

        if (this.count === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private doVarietySort (data: string) {
    this.showLoading = true
    this.scrollTop()

    let sort = false
    if (data === this.$store.state.varietyState.orderName) {
      if (this.$store.state.varietyState.sortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }

    this.$store.commit('varietyState/setOrderName', data)
    this.$store.commit('varietyState/setSortAsc', sort)
    this.getVarietyList()
  }

  private changeList () {
    this.showLoading = true
    this.$store.commit('varietyState/setOrderName', 'created_at')
    this.$store.commit('varietyState/setSortAsc', false)
    this.scrollTop()
    this.getVarietyList()
  }

  private scrollTop () : any {
    let varietyArea: any = document.getElementById('listContainer')!
    varietyArea.scrollTop = 0
  }
}
